import React from 'react';
import { useSelector } from 'react-redux';

import { DataSourceSlugs } from 'Shared/constants/types';

import './SuggestionsCalendarDisconnected.scss';
import { useTranslation } from 'Shared/utils/hooks/use-translation';
import { Tr } from 'Shared/components/i18n/Tr';

function SuggestionsCalendarDisconnected() {
  const { tr } = useTranslation();
  const googleSignUpUrl = useSelector(state => {
    const googleCalendarDataSource = state.data_sources.find(
      ({ slug }) => slug === DataSourceSlugs.googleCalendarWorkspaceSync
    );
    return googleCalendarDataSource?.path;
  });
  const office365SignUpUrl = useSelector(state => {
    const office365DataSource = state.data_sources.find(({ slug }) => slug === DataSourceSlugs.office365Calendar);
    return office365DataSource?.path;
  });

  const handleGoogleCalendarClick = () => {
    (window as any).analytics.track('Clicked in Add Workspace Modal', {
      modal: 'add_teammate_or_add_group',
      button: 'Connect Google Calendar',
    });
    window.location.href = googleSignUpUrl;
  };

  const handleOffice365Click = () => {
    (window as any).analytics.track('Clicked in Add Workspace Modal', {
      modal: 'add_teammate_or_add_group',
      button: 'Connect Office365 Calendar',
    });
    window.location.href = office365SignUpUrl;
  };

  return (
    <>
      <div className="add-teammate-sugestions-section-title pb-2">
        {tr('perform.simple_add_workspace.suggestions.calendar_disconnected.title')}
      </div>
      <div className="group-suggestions-calendar-disconnected p-2 border border-light">
        <Tr
          trKey="perform.simple_add_workspace.suggestions.calendar_disconnected.full_message"
          components={{
            google: <a href="#" onClick={handleGoogleCalendarClick} />,
            office365: <a href="#" onClick={handleOffice365Click} />,
          }}
        />
      </div>
    </>
  );
}

export default SuggestionsCalendarDisconnected;
